import { MouseEvent } from 'react';
import CloseIcon from '../icons/CloseIcon';

interface ISavedIconsPopup {
    setPopupShown: Function
}

const SavedIconsPopup = (props: ISavedIconsPopup) => {

    const close = () => {
        props.setPopupShown(false);
    };

    const prevent = (evt: MouseEvent) => {
        evt.stopPropagation();
    };

    return (
        <div
            className="fixed bg-black/75 w-screen h-screen left-0 top-0 z-50 flex items-center justify-center"
            onClick={ close }>

            <div
                className="bg-white text-gray-900 rounded-xl max-w-full relative"
                style={{
                    width: '390px'
                }}
                onClick={ prevent }>

                <button
                    type="button"
                    className="cursor-pointer absolute right-2 top-2"
                    onClick={ close }>
                    <CloseIcon />
                </button>

                <div className="p-10">
                    <b>Saved for later items</b> will only be stored in the <a className="underline text-blue-700" href="https://developer.mozilla.org/en-US/docs/Web/API/Window/localStorage" title="" target="_blank" rel="noreferrer">browser's local storage</a>. No data will be kept on the server, or in cookies. Local storage items may be cleared together with <a className="underline text-blue-700" href="https://support.google.com/accounts/answer/32050" title="" target="_blank" rel="noreferrer">browser cache</a>.
                </div>
            </div>
        </div>
    )
};

export default SavedIconsPopup;